module.exports = __webpack_public_path__ + "media/images/icon__checkmark@2x-ae705cc72c89be36a88a9d821dca1e96.png";